module.exports = __webpack_public_path__ + "static/media/filmaria.0cb89acb.gif";